export default "__VITE_ASSET__2f16d389__"